<script>
  import GlassBackground from './GlassBackground/index.svelte';

  /**
   * Confirmation dialog. Svelte 5 style: callbacks come in as props
   * (onConfirm / onCancel) and extra content via the additionalOptions
   * snippet. onConfirm receives { checkboxChecked }.
   */
  let {
    show = $bindable(false),
    title = 'Confirm Deletion',
    message = 'Are you sure you want to delete this item? This action cannot be undone.',
    confirmLabel = 'Delete',
    cancelLabel = 'Cancel',
    checkboxLabel = null,
    checkboxChecked = $bindable(false),
    onConfirm = () => {},
    onCancel = () => {},
    additionalOptions = null
  } = $props();

  function handleConfirm() {
    onConfirm({ checkboxChecked });
    show = false;
  }

  function handleCancel() {
    onCancel();
    show = false;
  }
</script>

{#if show}
  <div class="fixed inset-0 min-h-screen h-full flex items-center justify-center z-50">
    <GlassBackground class="w-full h-full">
      <div class="flex items-center justify-center w-full h-full">
        <div class="border border-gray-200 bg-white rounded-lg p-6 max-w-md w-full mx-4">
          <h2 class="text-xl font-bold mb-4">{title}</h2>
          <p class="mb-4">{message}</p>

          {#if checkboxLabel}
            <div class="mb-1">
              <label class="flex items-center">
                <input
                  type="checkbox"
                  bind:checked={checkboxChecked}
                  class="h-4 w-4 rounded border-gray-300 text-brand-700 focus:ring-brand-600"
                />
                <span class="ml-2 text-sm text-gray-700">{checkboxLabel}</span>
              </label>
            </div>
          {/if}

          {@render additionalOptions?.()}

          <div class="flex justify-end mt-6">
            <button
              onclick={handleCancel}
              class="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded mr-2"
            >
              {cancelLabel}
            </button>
            <button
              onclick={handleConfirm}
              class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </GlassBackground>
  </div>
{/if}
